"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnTypes = void 0;
var ColumnTypes;
(function (ColumnTypes) {
    ColumnTypes["Dimension"] = "Dimension";
    ColumnTypes["Event"] = "Event";
    ColumnTypes["Metric"] = "Metric";
    ColumnTypes["Cohorted"] = "Cohorted";
    ColumnTypes["DimensionAsMeasure"] = "DimensionAsMeasure";
    ColumnTypes["DimensionAsMeasureCPA"] = "DimensionAsMeasureCPA";
    ColumnTypes["DimensionAsMeasurePCPA"] = "DimensionAsMeasurePCPA";
    //App Measures: deprecated, keep for backward compatibility
    ColumnTypes["AppMeasure"] = "AppMeasure";
    ColumnTypes["AppMeasureCPA"] = "AppMeasureCPA";
    ColumnTypes["CohortedAppMeasure"] = "CohortedAppMeasure";
    ColumnTypes["CohortedAppMeasureCPA"] = "CohortedAppMeasureCPA";
    //App Measures: new type of app measures, to be used instead of deprecated ones
    ColumnTypes["AppMeasureV2"] = "AppMeasureV2";
    ColumnTypes["AppMeasureCPAV2"] = "AppMeasureCPAV2";
    ColumnTypes["AppMeasureSumV2"] = "AppMeasureSumV2";
})(ColumnTypes || (exports.ColumnTypes = ColumnTypes = {}));
